import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { openSocialPopup, stripHtmlTags } from 'helpers/utilities';
import { bikeModelSelector, bikeColourSelector } from 'src/redux/bike/selectors';
import Label from 'components/_utility/Label';
import useDataLayer from 'src/hooks/useDataLayer';
import { getLoadedConfiguration } from 'src/redux/garage/selectors';
import { basepathSelector } from 'src/redux/app/selectors';
import {
  Wrap,
  H4,
  Tagline,
  Partition,
  Input,
  InputTagline,
  SocialIcons,
  SocialIcon,
  CopyButton,
} from './ShareModal.styled';

const ShareModal = () => {
  const pushToDataLayer = useDataLayer();

  const model = useSelector(bikeModelSelector);
  const basepath = useSelector(basepathSelector);
  const configuration = useSelector(getLoadedConfiguration);
  const bikeColour = useSelector(bikeColourSelector);

  const url = `${window.location.origin + basepath}/bike/${model.id}/configure${
    configuration ? `?configurationId=${configuration.id}` : ''
  }`;
  const title = stripHtmlTags(model.name);
  const image = bikeColour.rightImage;

  const [copiedText, setCopiedText] = useState(false);

  const handleIconClick = e => {
    e.preventDefault();

    openSocialPopup(e.target.href);
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      pushToDataLayer('configuratorShareConfirm');
      setCopiedText(true);
    } catch (error) {
      console.error('Failed to copy text:', error);
    }
  };

  return (
    <Wrap>
      <H4>
        <Label name="shareBikeTitle"></Label>
      </H4>
      <Tagline>
        <Label name="shareBikeSubtitle"></Label>
      </Tagline>
      <SocialIcons>
        <SocialIcon onClick={handleIconClick} href={`http://www.facebook.com/sharer.php?u=${url}`} target="_blank">
          <img src="/images/configurator/social-icons/facebook.png" alt="Facebook" loading="lazy" />
        </SocialIcon>
        <SocialIcon onClick={handleIconClick} href={`https://twitter.com/intent/tweet?url=${url}`} target="_blank">
          <img src="/images/configurator/social-icons/twitter.png" alt="Twitter" loading="lazy" />
        </SocialIcon>
        <SocialIcon
          onClick={handleIconClick}
          href={`http://pinterest.com/pin/create/link/?url=${url}&media=${image}&description=${title}`}
          target="_blank"
        >
          <img src="/images/configurator/social-icons/pinterest.png" alt="Pinterest" loading="lazy" />
        </SocialIcon>
      </SocialIcons>
      <Partition>
        <InputTagline>
          <Label name="shareUrlLabel"></Label>
        </InputTagline>
        <Input value={url} readOnly></Input>
        <CopyButton onClick={handleCopy} primary>
          {copiedText ? <Label name="copiedButton"></Label> : <Label name="copyButton"></Label>}
        </CopyButton>
      </Partition>
    </Wrap>
  );
};

export default ShareModal;
